class Request {
    constructor() {
        const {
            common: {
                request: { get: ajaxGet, post: ajaxPost, bindCommonApi }
            }
        } = require('@futuweb/fego-render');
        this.get = ajaxGet;
        this.post = ajaxPost;

        this.bindCommonApi = bindCommonApi;
    }
}

export default function useCommonApi(service) {
    const request = new Request();
    const commonApiRequest = request.bindCommonApi(service);

    return commonApiRequest;
}
